<div class="my-3 my-md-5">
  <div class="container-fluid">
    <div class="col-sm-6 float-left">
        <h1 class="page-title">Lead Histories</h1>
    </div>
    <!-- <div class="col-sm-6 float-left add_user_btn">
        <a routerLink="/create-user" class="btn btn-success">
          <i class="fa fa-plus" aria-hidden="true"></i> Add User
      </a>
    </div> -->

  </div>

  <div class="container-fluid px-4 pt-4 card">
      <mat-accordion class="example-headers-align" multi>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                      <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                  <div class="row mb-4 mt-4">
                      <!-- <div class="col-sm-3"><input class="form-control" [(ngModel)]="search" type="text" (keyup)="loadUsersList(0,perpage)" placeholder="Search" /></div> -->
                      <div class="col-sm-3">
                          <mat-select  placeholder="Circle" (selectionChange)="getLeadHistories(0,perpage)" [(ngModel)]="circle" (click)="setSearchValue('circle')">
                              <input class="mySearchInput"
                              #circleSearch focused="'true'" type="text"
                              (keyup)="searchOnSelect($event.target.value, 'circle')"
                              (keydown)="$event.stopPropagation()" autocomplete="off"
                              placeholder="Search"
                              id="circleSearch">
                              <mat-option >All</mat-option>
                              <mat-option value="{{cir.id}}" *ngFor="let cir of circles">{{cir.name}}</mat-option>
                          </mat-select>
                      </div>
                      <div class="col-sm-3">
                        <mat-select  placeholder="User" (selectionChange)="getLeadHistories(0,perpage)" [(ngModel)]="user" (click)="setSearchValue('users')">
                            <input class="mySearchInput"
                            #usersSearch focused="'true'" type="text"
                            (keyup)="searchOnSelect($event.target.value, 'users')"
                            (keydown)="$event.stopPropagation()" autocomplete="off"
                            placeholder="Search"
                            id="usersSearch">
                            <mat-option >All</mat-option>
                            <mat-option value="{{u.id}}" *ngFor="let u of users">{{u.name}}</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-3 mt-2">
                      <mat-form-field appearance="fill">
                          <mat-label>Enter a date range</mat-label>
                          <mat-date-range-input [rangePicker]="picker">
                              <input matStartDate #dateRangeStart placeholder="Start date">
                              <input matEndDate #dateRangeEnd placeholder="End date" (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                          </mat-date-range-input>
                          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                          <mat-date-range-picker #picker></mat-date-range-picker>
                      </mat-form-field>
                      <mat-icon (click)="clearDate()">clear</mat-icon>
                  </div>
                  </div>
              </mat-expansion-panel>
      </mat-accordion>
      <div class="card">
          <div class="container-fluid row">
              <div class="col-sm-6 p-3"><button type="button" class="btn btn-success" [disabled]="loading" (click)="getLeadHistories(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i> Refresh List</button></div>
              <div class="col-sm-6"><mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex"></mat-paginator></div>
          </div>
          <div class="tableFixHead" style="overflow: scroll">
            <mat-card class="example-card" *ngFor="let lead of leadHistories;let index = index;">
              <mat-card-title class="lead-details">
                <span>
                  Lead Date: <span><i class="fas fa-clock"></i> {{lead.lead_time*1000|date:'dMMM, yyyy H:mm aa'}}</span>
                </span>
                <span>Lead Id : {{lead.lead_id}}</span>
                <span>Lead Name : {{lead.lead_name}}</span>
                <span>Lead Number : {{lead.mobile}}</span>
                <span>Lead Circle : {{lead.circle_name}}</span>
                <!-- <span>Lead Source : {{lead.lead_source}}</span> -->
              </mat-card-title>
              <mat-card-content>
                <ul style="padding-left: 0px;">
                  <li *ngFor="let history of lead.histories" class="listyle">
                      <span [innerHtml] = "history.message|safe:'html'"></span><br/>
                      <i class="fas fa-clock"></i> {{history.created_at*1000|date:'dMMM, yyyy H:mm aa'}}
                  </li>
                </ul>
              </mat-card-content>
              <mat-card-footer>
              </mat-card-footer>
            </mat-card>
            <div class="col-sm-12 text-center" *ngIf="loading"><i class="fa fa-spin fa-spinner fa-2x"></i></div>
            <div class="col-sm-12" *ngIf="loaded && !leadHistories.length">Today Lead histories not found!</div>
          </div>
          <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
      </div>


        </div>
</div>
